import React from 'react'

import styles from './styles.module.css'
import LegendItem from '../LegendItem/'

export default function(props) {
  const { lines } = props

  return (
    <div className={styles.legend}>
      {lines.map((line, i) => {
        return (
          <LegendItem
            line={line}
            i={i}
            width={80}
            height={30}
            key={line.title}
          />
        )
      })}
    </div>
  )
}
